import request from 'services/axios';

export const sendRplyMSG = async (payload: ISendReplyChat) => {
  const {data} = await request.post(`/api/v2/chat/market-send-message`, {
    ...payload,
  });
  return data;
};
